import React from 'react';
import { ThemeProvider as Provider, Theme as DefaultTheme } from '@material-ui/core/styles';
import createTheme, { DEFAULT_THEME } from './createTheme';
import CssBaseline from '@material-ui/core/CssBaseline';
export * as locales from './theme/locales';
export * from '@material-ui/core/styles';

export interface ThemeProviderProps<Theme = DefaultTheme> {
    children: React.ReactNode;
    theme?: Partial<Theme> | ((outerTheme: Theme) => Theme);
    withNormalizeCSS?: boolean;
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children, theme, withNormalizeCSS }) => {
    return (
        <Provider theme={theme || createTheme()}>
            {withNormalizeCSS && <CssBaseline />}
            {children}
        </Provider>
    );
};

export { createTheme, ThemeProvider };

export default DEFAULT_THEME;
